import './supHeader.css';
import Logo from '../../../assets/images/trvto-logo.png';
import MenuIcon from '../../../assets/icons/trvto_downArrow.svg';
import UserIcon from '../../../assets/icons/trvto_user.svg';
import { useState } from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import AddIcon from '../../../assets/icons/trvto_plus.svg';
import SupHeadDrop from './supHeadDrop/SupHeadDrop';

export default function SupHeader({ setAddBo }) {
    const location = useLocation();
    const orgId = location.pathname.split('/')[4];
    const [headDrop, setHeadDrop] = useState(false);
    const name = localStorage.getItem('supName');
    const { mode } = useParams();
    const isOnlyPackages = location.pathname.startsWith(`/support/${mode}/packages/`);
    const packConfig = {
        g: 'Create Guide',
        t: 'Create Package',
        a: 'Create Activity',
        c: 'Create Camp'
    };

    return (
        <div className='supHeaderHomeDiv'>
            <div className='logoContainer'>
                <img alt='travel logo' src={Logo} width='120' height='50' />
            </div>
            <div className='supTabsEndDiv'>
                {orgId && (
                    <button
                        className='orgTabsHeading add-btn'
                        onClick={() => {
                            setAddBo(true);
                        }}
                    >
                        <img alt='trvto_add-icn' src={AddIcon} className='orgHeaderMenuIcon' />
                        Add Booking
                    </button>
                )}
                {orgId && isOnlyPackages && (
                    <Link
                        className='orgTabsHeading add-btn'
                        to={`/support/${mode}/create/pack/${orgId}`}
                        target='_blank'
                        rel='noopener noreferrer'
                        onClick={() => {
                            if (mode === 'c') {
                                localStorage.removeItem('trvto_accommodation_draft');
                            }
                        }}
                    >
                        <img alt='trvto_add-icn' src={AddIcon} className='orgHeaderMenuIcon' />
                        {packConfig[mode]}
                    </Link>
                )}
                <button
                    className='supTabsHeading menu'
                    onClick={() => {
                        setHeadDrop(true);
                    }}
                >
                    <img alt='trvto_user' src={UserIcon} width={16} height={16} />
                    {name?.charAt(0).toUpperCase() + name?.slice(1)}
                    <img alt='trv_to_menu-icon' src={MenuIcon} className='supHeaderMenuIcon' />
                </button>
            </div>
            {headDrop && <div className='overlay' onClick={() => setHeadDrop(false)}></div>}
            {headDrop && <SupHeadDrop setHeadDrop={setHeadDrop} />}
        </div>
    );
}
